import React, { useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { color, motion } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import AllCountries from "../../components/v4/AllCountries/AllCountries";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import bodySectionBg from "../../images/v4/country/philippines/images/bodySectionBg.png";
import heroBg from "../../images/v4/country/philippines/images/heroBg.png";

import philippines from "../../images/v4/country/philippines/icons/philippines.svg";

import bestIcon1 from "../../images/v4/country/india/icons/bestIcon1.svg";
import bestIcon2 from "../../images/v4/country/india/icons/bestIcon2.svg";
import bestIcon3 from "../../images/v4/country/india/icons/bestIcon3.svg";
import bestIcon4 from "../../images/v4/country/india/icons/bestIcon4.svg";
import bestIcon5 from "../../images/v4/country/india/icons/bestIcon5.svg";

import smartIcon1 from "../../images/v4/country/india/icons/smartIcon1.svg";
import smartIcon2 from "../../images/v4/country/india/icons/smartIcon2.svg";
import smartIcon3 from "../../images/v4/country/india/icons/smartIcon3.svg";
import smartIcon4 from "../../images/v4/country/india/icons/smartIcon4.svg";
import smartIcon5 from "../../images/v4/country/india/icons/smartIcon5.svg";
import smartIcon6 from "../../images/v4/country/india/icons/smartIcon6.svg";
import smartIcon7 from "../../images/v4/country/india/icons/smartIcon7.svg";
import smartIcon8 from "../../images/v4/country/india/icons/smartIcon8.svg";
import smartIcon9 from "../../images/v4/country/india/icons/smartIcon9.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/industry/education/images/compareItemImg3.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/country/malaysia/images/compareItemImg5.png";

import countryBackground from "../../images/v4/country/philippines/images/countryBackground.png";
import benefitImg from "../../images/v4/country/philippines/images/benefitImg.png";

import realWorldImg1 from "../../images/v4/country/philippines/images/realWorldImg1.png";
import realWorldImg2 from "../../images/v4/country/philippines/images/realWorldImg2.png";
import realWorldImg3 from "../../images/v4/country/philippines/images/realWorldImg3.png";
import realWorldImg4 from "../../images/v4/country/philippines/images/realWorldImg4.png";
import SEO from "../../components/SEO";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: `url(${heroBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    padding: "100px 0 60px",
    "& .countryHighlight": {
      background:
        "linear-gradient(90deg, #00B661 66.37%, #FFB54B 81.73%, #FF1D5A 96.98%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "16px",
      width: "85%",
      margin: "0 auto",
      textAlign: "center",
      "& .buttonContaienr": {
        justifyContent: "center",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
        marginTop: "0px",
        "& .buttonContaienr": {
          alignItems: "center",
        },
        "& .primaryButton": {
          width: "100%",
        },
        "& .countryLogo": {
          width: "30px",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    // flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "100%",
      gap: "15px",
    },
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid #00B661",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {
      minWidth: "90%",
    },
    // color: "#A2BED3",
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(180deg, #009A99 0%, #1C297E 100%)",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "540px",
      "& $supportBox": {
        top: "-770px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: 0,
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0 15px",
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(0.1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 40px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  stripSection: {
    backgroundColor: "#e9f4fe",
    // backgroundImage: `url(${partnerSectionBackground})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  testimonials: {
    background: "#e9f4fe",
  },
  wpFaq: {
    padding: "40px 0",
    background: "#eaffff",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background: "linear-gradient(to right, #011d32 -1%, #00182b 100%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  growingBusiness: {
    //paddingTop: "60px",
    backgroundImage: `url(${bodySectionBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingBottom: "300px",
    position: "relative",
    "& .header": {
      width: "50%",
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "& .body": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "20px",
      flexWrap: "wrap",
      marginTop: "60px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0 300px",
      "& .header": {
        width: "100%",
      },
    },
    "& $broadcastLeftContainer": {
      width: "55%",
    },
  },
  practiceCard: {
    background: "#ffffff1a",
    borderRadius: "16px",
    padding: "24px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: "16px",
    width: "32%",
    opacity: "1",
    backdropFilter: "blur(30px) brightness(1)",
    transition: "0.3s ease",
    "&:hover": {
      backdropFilter: "blur(50px) brightness(1.2)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  countrySection: {
    padding: "60px 0",
    borderRadius: "40px 40px 0 0",
    backgroundImage: `url(${countryBackground})`,
    backgroundSize: "cover",
    "& .header": {
      width: "60%",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .cards": {
      display: "flex",
      width: "100%",
      justifyContent: "flex-start",
      gap: "20px",
      alignItems: "stretch",
      marginTop: "60px",
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        marginTop: "40px",
      },
    },
    "& .card": {
      padding: "32px 24px",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "32px",
      backdropFilter: "blur(20px)",
      border: "1px solid #534B69 ",
      width: "48%",
      background:
        "linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "0",
    },
  },
  tabsSection: {
    background: "#F1FAF9",
    paddingTop: "280px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-530px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
        marginTop: 0,
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "550px",
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  tabsContainer: {
    width: "90%",
    minWidth: "max-content",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "10px",
      padding: "5px",
      overflow: "auto",
      minWidth: "100%",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  tab: {
    width: "25%",
    minWidth: "max-content",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px 15px",
    },
  },
  tabCard: {
    marginTop: "20px",
    gap: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
      flexDirection: "column",
    },
  },
  tabCardLeftContainer: {
    width: "50%",
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    position: "relative",
    top: "5px",
  },
  supportBox: {
    top: "100%",
    width: "100%",
    display: "flex",
    padding: "40px",
    background: "linear-gradient(180deg, #009A99 -7.76%, #002C51 100%)",
    position: "relative",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "& $broadcastLeftContainer": {
      width: "55%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "94%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  adaptFeatures: {
    backgroundrepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${heroBg})`,
    "& .header": {
      display: "flex",
      width: "55%",
      gap: "10px",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .container": {
      paddingBottom: "35px",
    },
  },
  adaptSlider: {
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
  },
  adaptsBox: {
    gap: "16px",
    display: "flex",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    maxWidth: "380px",
    minHeight: "220px",
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
  },
  adaptBoxHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
  },
}));

const Philippines = () => {
  const classes = useStyles();
  const [activeCompare, setActiveCompare] = useState("#section0");
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];
  const faqs = [
    {
      question:
        "What is a CRM system, and why is it important for businesses in the Philippines?",
      answer: (
        <>
          A Customer Relationship Management (CRM) system is a tool that helps
          businesses manage interactions with current and potential customers.
          For Philippine businesses, a CRM system enhances customer engagement,
          streamlines processes, and drives sales growth by providing a
          centralised platform for customer data and communication.
        </>
      ),
    },
    {
      question:
        "How to get CRM software for your growing business in the Philippines?",
      answer: (
        <>
          Getting started with the best CRM software provider in the Philippines
          is simple and cost-effective! Whether you're a startup in Manila or an
          SME in Cebu, Pepper Cloud CRM offers an easy onboarding process:
          <ul>
            <li>
              Book a free demo to explore Pepper Cloud CRM with a personalised
              walkthrough.
            </li>
            <li>
              Consult with local CRM experts in the Philippines to select the
              right plan.
            </li>
            <li>
              No setup fees and an intuitive interface designed for quick
              deployment.
            </li>
            <li>
              Customise the CRM for your business workflows, pipelines, and
              automation needs.
            </li>
            <li>
              Go live and start selling smarter, faster, and better with Pepper
              Cloud’s AI-powered tools.
            </li>
          </ul>
        </>
      ),
    },
    {
      question:
        "How to choose the best CRM software for your Philippine business?",
      answer: (
        <>
          When selecting a CRM software provider in the Philippines, keep these
          factors in mind:
          <ul>
            <li>Scalability – Choose a CRM that grows with your business.</li>
            <li>
              Customisation – Make sure the CRM fits your industry needs and
              sales workflows.
            </li>
            <li>
              Integration capabilities – Look for seamless integration with
              tools like accounting software, social media, and email marketing.
            </li>
            <li>
              24/7 Local Support in the Philippines – Partner with CRM companies
              in the Philippines that offer region-specific assistance.
            </li>
            <li>
              Affordable pricing – Select a CRM software that delivers great
              value for your investment, especially for small and medium
              businesses in the Philippines.
            </li>
          </ul>
        </>
      ),
    },
    {
      question:
        "Can small businesses in the Philippines benefit from CRM systems?",
      answer: (
        <>
          Yes! Small businesses in the Philippines can benefit immensely from
          using CRM software. Whether you want to track leads, automate
          follow-ups, or strengthen customer engagement, CRM solutions like
          Pepper Cloud help businesses stay organised and competitive in the
          local market.
        </>
      ),
    },
    {
      question:
        "What are the common benefits and challenges of using CRM software in the Philippines?",
      answer: (
        <>
          Benefits:
          <ul>
            <li>Enhanced customer relationship management.</li>
            <li>Increased sales productivity and lead conversion.</li>
            <li>Real-time data insights for smarter business decisions.</li>
          </ul>
          Challenges:
          <ul>
            <li>Initial setup and team training.</li>
            <li>Data migration from legacy systems.</li>
            <li>Driving adoption across departments.</li>
          </ul>
        </>
      ),
    },
    {
      question: "How does Pepper Cloud CRM cater to the Philippine market?",
      answer: (
        <>
          Pepper Cloud CRM is designed for Filipino businesses with:
          <ul>
            <li>
              Integrated WhatsApp and social media communication tools for local
              customer engagement.
            </li>
            <li>
              Tailored features to match the needs of industries in the
              Philippines, from real estate to retail.
            </li>
            <li>Strong data protection aligned with Philippine regulations.</li>
          </ul>
        </>
      ),
    },
    {
      question:
        "Does Pepper Cloud CRM offer mobile access for businesses in the Philippines?",
      answer: (
        <>
          Yes! Pepper Cloud CRM offers full mobile access through iOS and
          Android apps, allowing sales and support teams in the Philippines to
          manage leads and customer interactions anytime, anywhere.
        </>
      ),
    },
    {
      question:
        "How does CRM software improve sales processes for Philippine businesses?",
      answer: (
        <>
          CRM software enhances sales processes by providing tools for lead
          tracking, sales pipeline management, and customer segmentation. It
          enables sales teams to prioritise leads, automate follow-ups, and
          access real-time data, leading to increased efficiency and higher
          conversion rates.
        </>
      ),
    },
  ];

  const compareItems = [
    "Pepper Cloud CRM",
    "Salesforce",
    "Zoho CRM",
    "HubSpot CRM",
    "Microsoft Dynamics 365",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud emerges as the top choice for businesses in the Philippines, offering a powerful, integrated platform designed to meet diverse business needs. With a combination of AI-powered automation, omnichannel communication, and real-time analytics, it provides a seamless experience for managing sales, marketing, and support. Ideal for businesses of all sizes, Pepper Cloud ensures efficiency, scalability, and success.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "AI automation suite",
          desc: "Automate repetitive tasks with AI-driven features, freeing up time for strategic sales and marketing efforts.",
        },
        {
          title: "Omnichannel Communication",
          desc: "Engage customers through multiple channels, including WhatsApp, Email, and Social Media, for seamless and efficient communication.",
        },
        {
          title: "Customisable Dashboards",
          desc: "Gain real-time insights with customisable dashboards, tailored to your business needs for improved decision-making and performance tracking.",
        },
        {
          title: "Real-Time Analytics",
          desc: "Make informed decisions with powerful, real-time analytics and reporting tools.",
        },
        {
          title: "Affordable Pricing",
          desc: "Benefit from affordable pricing without compromising on quality or functionality, making Pepper Cloud the best value in the market.",
        },
      ],
      cta: "Get demo",
    },
    {
      title: "Salesforce",
      desc: "Salesforce CRM offers extensive customisation options and a wide range of integrations, making it ideal for larger enterprises in the Philippines. With its scalability and flexibility, it is well-suited for businesses seeking comprehensive CRM capabilities.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "Customisation options",
          desc: "Tailor the platform to meet specific business needs with advanced customisation features.",
        },
        {
          title: "Wide range of integrations",
          desc: "Seamlessly connect Salesforce with other tools for enhanced functionality.",
        },
        {
          title: "Scalability",
          desc: "Designed to grow with your business, offering the flexibility to scale.",
        },
        {
          title: "Premium pricing",
          desc: "Although priced at a premium, Salesforce provides advanced features and reliability for enterprises in the Philippines.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM is a cost-effective solution for small to mid-sized businesses in the Philippines. Offering a comprehensive range of features, from lead management to email marketing, Zoho is a strong choice in the CRM software market.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Flexible plans",
          desc: "Zoho’s plans are designed to meet the needs of startups and growing businesses, offering scalable solutions at budget-friendly prices.",
        },
        {
          title: "Lead management",
          desc: "Capture, track, and manage leads efficiently to drive growth.",
        },
        {
          title: "Email marketing",
          desc: "Create and manage targeted email campaigns to engage with customers effectively.",
        },
        {
          title: "Affordable pricing",
          desc: "Zoho offers reliable CRM solutions at a competitive price point for businesses in the Philippines.",
        },
      ],
    },
    {
      title: "HubSpot CRM",
      desc: "HubSpot CRM is known for its ease of use and marketing-friendly tools, making it a popular choice for businesses in the Philippines. With a clean, intuitive interface and strong marketing automation capabilities, HubSpot simplifies customer engagement.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Ease of use",
          desc: "The platform’s intuitive interface makes it easy to navigate and use.",
        },
        {
          title: "Marketing automation",
          desc: "Automate marketing tasks to drive engagement and streamline customer interactions.",
        },
        {
          title: "Ideal for startups",
          desc: "Perfect for businesses starting out in the CRM software Philippines space, offering a user-friendly and scalable solution.",
        },
        {
          title: "Attractive option",
          desc: "HubSpot CRM is an excellent choice for businesses looking to simplify their customer engagement strategies.",
        },
      ],
    },
    {
      title: "Microsoft Dynamics 365",
      desc: "Microsoft Dynamics 365 combines CRM and ERP capabilities into a single, integrated solution. Businesses already using Microsoft’s ecosystem will benefit from seamless integration with Office 365 and other Microsoft services.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "CRM and ERP integration",
          desc: "A unified solution that combines both CRM and ERP for enhanced efficiency.",
        },
        {
          title: "Seamless integration",
          desc: "Easily integrate with Office 365 and other Microsoft tools for smooth workflows.",
        },
        {
          title: "Enterprise-grade features",
          desc: "Ideal for organisations seeking robust features and support from a trusted CRM provider in the Philippines.",
        },
        {
          title: "Trusted solution",
          desc: "Dynamics 365 provides scalable, enterprise-level solutions for businesses looking for comprehensive support.",
        },
      ],
    },
  ];

  const bestPractice = [
    {
      icon: smartIcon1,
      alt: "",
      heading: "AI-powered efficiency",
      desc: "Automate routine tasks and enhance customer service with features offered by CRM software Philippines.",
    },
    {
      icon: smartIcon2,
      alt: "",
      heading: "Lead management",
      desc: "Centralise lead tracking across platforms — a key feature of many CRM companies in the Philippines.",
    },
    {
      icon: smartIcon3,
      alt: "",
      heading: "Sales pipeline management",
      desc: "Trusted CRM companies in the Philippines offer visual tools to help manage your sales journey.",
    },
    {
      icon: smartIcon4,
      alt: "",
      heading: "Automated workflows",
      desc: "Automate tasks like follow-ups and lead routing, a benefit provided by most CRM software platforms.",
    },
    {
      icon: smartIcon5,
      alt: "",
      heading: "WhatsApp CRM",
      desc: "Essential for businesses seeking to connect with local clients, and often offered by CRM companies in the Philippines.",
    },
    {
      icon: smartIcon6,
      alt: "",
      heading: "Multichannel communication",
      desc: "A core function of CRM software Philippines, unifying email, chat, and social platforms.",
    },
    {
      icon: smartIcon7,
      alt: "",
      heading: "Task and activity management",
      desc: "Plan and prioritise effortlessly with tools from CRM providers Philippines.",
    },
    {
      icon: smartIcon8,
      alt: "",
      heading: "Mobile CRM app",
      desc: "Access your CRM on the go, a must-have from most CRM companies in the Philippines.",
    },
    {
      icon: smartIcon9,
      alt: "",
      heading: "CRM integrations",
      desc: "Connect seamlessly with other business tools, a standout feature of top CRM software Philippines.",
    },
  ];
  const tabContentData = [
    {
      tabContent: [
        {
          heading: "Efficient property listings",
          content:
            "Organize with custom dashboards, auto-updated listings, and fewer errors.",
          alt: "Real Estate CRM",
        },
        {
          heading: "Client communication",
          content: "Engage buyers and sellers with omnichannel tools and data.",
          alt: "Real Estate CRM",
        },
        {
          heading: "Streamlined sales process",
          content:
            "Use AI to track funnels, automate follow-ups, and close deals.",
          alt: "Real Estate CRM",
        },
      ],
      img: realWorldImg1,
      alt: "Real Estate CRM for Philippines",
      subtitle:
        "The real estate sector in the Philippines needs fast, client-focused processes. Our CRM software helps firms stay organized and responsive.",
    },
    {
      tabContent: [
        {
          heading: "Patient information management",
          content:
            "Secure, accessible records with a centralised customer database.",
          alt: "Healthcare CRM",
        },
        {
          heading: "Appointment scheduling",
          content:
            "Automate reminders with marketing automation tools to reduce no-shows.",
          alt: "Healthcare CRM",
        },
        {
          heading: "Follow-ups & engagement",
          content:
            "Boost retention with auto follow-ups on multichannel platforms.",
          alt: "Healthcare CRM",
        },
      ],
      img: realWorldImg2,
      alt: "Healthcare CRM for Philippines",
      subtitle:
        "Healthcare professionals and clinics in the Philippines use CRM tools to streamline patient engagement and data flow, improving care coordination.",
    },
    {
      tabContent: [
        {
          heading: "Student admissions & enrollment",
          content: "Simplify enrolment workflows with AI-powered automation.",
          alt: "Education CRM",
        },
        {
          heading: "Communication & engagement",
          content: "Connect with all via omnichannel suite for timely updates.",
          alt: "Education CRM",
        },
        {
          heading: "Academic records management",
          content:
            "Store records easily with dashboards to boost admin productivity.",
          alt: "Education CRM",
        },
      ],
      img: realWorldImg3,
      alt: "Education CRM for Philippines",
      subtitle:
        "Educational institutions in the Philippines use CRM software to manage the full student lifecycle, from admission to graduation.",
    },
    {
      tabContent: [
        {
          heading: "Customer relationship management",
          content:
            "Anticipate needs with real-time analytics and reporting tools.",
          alt: "Retail CRM",
        },
        {
          heading: "Loyalty programs & marketing",
          content:
            "Run personalised campaigns with automation to boost retention.",
          alt: "Retail CRM",
        },
        {
          heading: "Inventory & sales management",
          content:
            "Sync sales with inventory via custom integrations for smart stocking.",
          alt: "Retail CRM",
        },
      ],
      img: realWorldImg4,
      alt: "Retail CRM for Philippines",
      subtitle:
        "Retail businesses in the Philippines use CRM software to manage customer relationships, inventory, and automate sales for better growth.",
    },
  ];
  const cards = [
    {
      heading: "What is CRM software Philippines?",
      content:
        "CRM software Philippines streamlines business processes, manages customer relationships, and boosts profitability. CRM companies in the Philippines offer advanced solutions for agility and growth. Choosing the right CRM software Philippines ensures efficient and impactful customer interactions.",
    },
    {
      heading: "Why do Philippine businesses need a CRM?",
      content:
        "CRM companies in the Philippines offer platforms to manage client data, enhance service, and drive growth. CRM software Philippines provides scalable, affordable solutions for SMEs and large enterprises. Partnering with top CRM companies in the Philippines boosts efficiency and customer satisfaction.",
    },
  ];
  const adaptList = [
    {
      pointer: "All-in-one CRM solution",
      desc: "Pepper Cloud integrates sales, marketing, and support, making it a standout CRM software provider in the Philippines.",
      img: bestIcon1,
    },
    {
      pointer: "AI-powered automation",
      desc: "Automate tasks and gather real-time insights — a feature praised by CRM companies in the Philippines.",
      img: bestIcon2,
    },
    {
      pointer: "Customisable dashboards",
      desc: "Visualise data your way, a common strength among top CRM companies in the Philippines.",
      img: bestIcon3,
    },
    {
      pointer: "Affordable pricing",
      desc: "Flexible plans, perfect for businesses looking for scalable CRM software Philippines.",
      img: bestIcon4,
    },
    {
      pointer: "24/7 local support",
      desc: "Accessible support from experts based in the Philippines, reinforcing Pepper Cloud’s reputation as a leading CRM software provider in the Philippines.",
      img: bestIcon5,
    },
  ];
  const pointers = [
    "Centralised customer information for better organisation.",
    "Improved customer service through timely responses.",
    "Enhanced marketing strategies with targeted campaigns.",
    "Increased sales efficiency and higher conversion rates.",
  ];
  return (
    <main>
      <SEO
        title={"Best AI-powered CRM software in Philippines | Pepper Cloud CRM"}
        pathname={
          "https://peppercloud.com/country/best-crm-software-in-philippines/"
        }
        keywords="software provider in the Philippines, crm software provider in the philippines, crm providers philippines, crm companies in philippines, crm software philippines"
        description={
          "Boost sales with Pepper Cloud — the best CRM in the Philippines! AI automation, multichannel chat & custom dashboards. Book your free demo today!"
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is a CRM system, and why is it important for businesses in the Philippines?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A Customer Relationship Management (CRM) system is a tool that helps businesses manage interactions with current and potential customers. For Philippine businesses, a CRM system enhances customer engagement, streamlines processes, and drives sales growth by providing a centralised platform for customer data and communication.",
                },
              },
              {
                "@type": "Question",
                name: "How to get CRM software for your growing business in the Philippines?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Getting started with the best CRM software provider in the Philippines is simple and cost-effective! Whether you're a startup in Manila or an SME in Cebu, Pepper Cloud CRM offers an easy onboarding process: Book a free demo to explore Pepper Cloud CRM with a personalised walkthrough. Consult with local CRM experts in the Philippines to select the right plan. No setup fees and an intuitive interface designed for quick deployment. Customise the CRM for your business workflows, pipelines, and automation needs. Go live and start selling smarter, faster, and better with Pepper Cloud’s AI-powered tools.",
                },
              },
              {
                "@type": "Question",
                name: "How to choose the best CRM software for your Philippine business?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "When selecting a CRM software provider in the Philippines, keep these factors in mind: Scalability – Choose a CRM that grows with your business. Customisation – Make sure the CRM fits your industry needs and sales workflows. Integration capabilities – Look for seamless integration with tools like accounting software, social media, and email marketing. 24/7 Local Support in the Philippines – Partner with CRM companies in the Philippines that offer region-specific assistance. Affordable pricing – Select a CRM software that delivers great value for your investment, especially for small and medium businesses in the Philippines.",
                },
              },
              {
                "@type": "Question",
                name: "Can small businesses in the Philippines benefit from CRM systems?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes! Small businesses in the Philippines can benefit immensely from using CRM software. Whether you want to track leads, automate follow-ups, or strengthen customer engagement, CRM solutions like Pepper Cloud help businesses stay organised and competitive in the local market.",
                },
              },
              {
                "@type": "Question",
                name: "What are the common benefits and challenges of using CRM software in the Philippines?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Benefits: Enhanced customer relationship management. Increased sales productivity and lead conversion. Real-time data insights for smarter business decisions. Challenges: Initial setup and team training. Data migration from legacy systems. Driving adoption across departments.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud CRM cater to the Philippine market?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is designed for Filipino businesses with: Integrated WhatsApp and social media communication tools for local customer engagement. Tailored features to match the needs of industries in the Philippines, from real estate to retail. Strong data protection aligned with Philippine regulations.",
                },
              },
              {
                "@type": "Question",
                name: "Does Pepper Cloud CRM offer mobile access for businesses in the Philippines?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes! Pepper Cloud CRM offers full mobile access through iOS and Android apps, allowing sales and support teams in the Philippines to manage leads and customer interactions anytime, anywhere.",
                },
              },
              {
                "@type": "Question",
                name: "How does CRM software improve sales processes for Philippine businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "CRM software enhances sales processes by providing tools for lead tracking, sales pipeline management, and customer segmentation. It enables sales teams to prioritise leads, automate follow-ups, and access real-time data, leading to increased efficiency and higher conversion rates.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.heroSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h1
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-72 color-black1"
            >
              Boost relationships with the best CRM in the{" "}
              <img
                className="countryLogo"
                src={philippines}
                alt="philippines"
              />{" "}
              <span className="countryHighlight">Philippines</span>
            </motion.h1>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18 color-black2 mt10"
              //   style={{ color: "#A2BED3" }}
            >
              Discover the best CRM software provider in the Philippines with
              Pepper Cloud — designed to streamline sales, automate workflows,
              and boost customer engagement for faster business growth.
            </motion.p>
            <div className={classes.listContainer}>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Seamless multichannel communication
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Affordable for all business sizes
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  AI-powered automation
                </p>
              </div>
            </div>
            <div className="buttonContaienr mt40">
              <Link
                to="/contact/"
                className="primaryButton font-20 font-wix-medium font-white"
              >
                Book a free demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.countrySection}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              A quick guide about the best CRM software in Philippines
            </motion.h2>
          </div>
          <div className="cards">
            {cards.map((card) => (
              <div className="card">
                <p className="font-24 font-wix-semibold font-white">
                  {card.heading}
                </p>
                <p className="font-wix-regular font-18 font-white">
                  {card.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={classes.adaptFeatures}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-medium font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Why Pepper Cloud is the best CRM software in the Philippines
            </motion.h2>
          </div>
        </div>
        <Swiper
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            // 768: {
            //   slidesPerView: "auto",
            //   slidesPerGroup: 3,
            //   spaceBetween: 30,
            //   grabCursor: true,
            // },
          }}
          className={classes.adaptSlider}
          slidesPerView={3.3}
          // centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          loop={true}
          speed={5000}
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  alt={point.pointer}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold ">{point.pointer}</p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Everything you need to sell smarter, faster, and better
            </motion.h2>
          </div>
          <div className="body">
            {bestPractice.map((practice) => (
              <div className={classes.practiceCard}>
                <img src={practice.icon} alt={practice.heading} />
                <p className="font-wix-semibold font-24 font-white">
                  {practice.heading}
                </p>
                <p
                  className="font-wix-medium font-16"
                  style={{ color: "#E9F4FE" }}
                >
                  {practice.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          {/* <TruestedSection background={true} /> */}
        </div>
      </section>
      <section className={classes.tabsSection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                Benefits of using a CRM system for your Philippine small
                business
              </p>
              <div className={classes.pointers}>
                {pointers.map((pointer) => (
                  <div className={classes.cardPointer}>
                    <LazyImage
                      source={whiteCheckCircle}
                      className={classes.pointerImg}
                      alt={"pointer"}
                    />
                    <p className="font-inter-regular font-18 font-white">
                      {pointer}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={benefitImg}
                alt={
                  "Benefits of using a CRM system for your Philippine small business"
                }
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Application and use cases of CRM system in the Philippines
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                CRM for real estate
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                CRM for healthcare
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                CRM for education
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                CRM for retail
              </div>
            </div>
          </div>
          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 color-black2"
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.benfitListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3 }}
                            className={classes.benfitListItem}
                          >
                            <LazyImage
                              source={greenCheckCircle}
                              className={classes.benfitIcon}
                              alt={item.alt}
                            />
                            <div className={classes.benfitListItemContent}>
                              <p className="font-wix-semibold font-20 color-black1">
                                {item.heading}
                              </p>
                              <p className="font-wix-regular font-16 color-black2">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        source={listItem.img}
                        alt={listItem.alt}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-black1"
            >
              5 best CRM software in Philippines in 2025
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    href={`#section${index}`}
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-40 font-wix-semibold font-black1"
                  >
                    {data.title}
                  </h3>
                  <p
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-inter-regular font-18 font-black1"
                  >
                    {data.desc}
                  </p>
                  <img src={data.img} className="productImage" alt={data.alt} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                      >
                        <div className={classes.header}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            src={downArrow}
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-inter-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <TruestedSection />
      <section className={classes.stripSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              Best CRM with WhatsApp integration - Trusted by SMEs globally
            </motion.h3>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={3000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 20,
            },
            // For larger screens (desktop)
            768: {
              freeMode: false,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              speed: 3000,
              loop: true,
              allowTouchMove: true,
            },
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          noButton={true}
          heading={"Real stories. Real results."}
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
        />
      </div>
      <AllCountries />
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#eaffff"}
          heading={"FAQs - Best CRM software in Philippines"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Seamless sales, unforgettable customer journeys!
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/"
            >
              Book a free demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Philippines;
